export default {
    _prefix: "AgreementRate",
    label: "Agreement Score",
    percentage: (data: { percentage: number }) => "{{percentage}}%",
    tooltip: {
        draftFormAgreementRateInfo:
            "Click 'View published form' to see agreement rates for automated questions on the last published form.",
        formAgreementRateInfo:
            "Agreement score shows how often users accepted AI-suggested answers across the entire form. A higher score means the form's questions are well-structured for AI.",
        questionAgreementRateInfo:
            "Agreement score shows how often users accepted AI-suggested answers. Well-written questions and help text typically lead to higher scores.",
    },
    draftFormAgreementRateLabel: "Published form agreement score",
    viewPublishedForm: "View published form",
    ariaLabels: {
        goodAgreementRate: "Good agreement rate",
        moderateAgreementRate: "Moderate agreement rate",
        lowAgreementRate: "Low agreement rate",
        agreementRatePercentage: (data: { percentage: number }) =>
            "{{percentage}} percent agreement rate",
    },
};
